import { fromJS } from 'immutable';

export const LOGIN = 'kroost/user/LOGIN';
export const REGISTER = 'kroost/user/REGISTER';
export const LOGOUT = 'kroost/user/LOGOUT';
export const SET_TOKEN = 'kroost/user/SET_TOKEN';
export const UPDATE_CHILDREN = 'kroost/user/UPDATE_CHILDREN';
export const ADD_CHILD = 'kroost/user/ADD_CHILD';
export const UPDATE_PROFILE = 'kroost/user/UPDATE_PROFILE';
export const UPDATE_ANALYTICS_PROFILE = 'kroost/user/UPDATE_ANALYTICS_PROFILE';
export const FAILED_LOGIN = 'kroost/user/FAILED_LOGIN';
export const FAILED_REGISTER = 'kroost/user/FAILED_REGISTER';
export const FAILED_PASSWORD_RESET = 'kroost/user/FAILED_PASSWORD_RESET';
export const REQUEST_RESET_PASSWORD = 'kroost/user/REQUEST_RESET_PASSWORD';
export const RESET_PASSWORD = 'kroost/user/RESET_PASSWORD';
export const TRACK_EVENT = 'kroost/user/TRACK_EVENT';

// Initial routing state
const initialState = fromJS({
  token: null,
  profile: null,
  children: null,
  loading: false,
  failedLogin: null,
  failedRegister: null,
  failedPasswordReset: false,
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_TOKEN:
      return state
        .set('token', action.token || null)
        .set('loading', false)
        .set('failedLogin', false)
        .set('failedRegister', false)
        .set('failedPasswordReset', false);
    case REGISTER:
      return state.set('loading', true);
    case UPDATE_PROFILE:
      return state.set('profile', action.profile ? fromJS(action.profile) : null);
    case UPDATE_CHILDREN:
      return state.set('children', action.children ? fromJS(action.children) : null);
    case FAILED_LOGIN:
      return state.set('failedLogin', action.code || null);
    case FAILED_REGISTER:
      return state.set('failedRegister', action.code || null);
    case FAILED_PASSWORD_RESET:
      return state.set('failedPasswordReset', true);
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
}

export function login(email, password) {
  return {
    type: LOGIN,
    email,
    password,
  };
}

export function register(first_name, email, password, successScreen = 'myOrders') {
  return {
    type: REGISTER,
    first_name,
    email,
    password,
    successScreen,
  };
}

export function requestResetPassword(email) {
  return {
    type: REQUEST_RESET_PASSWORD,
    email,
  };
}

export function resetPassword(user_id, token, password) {
  return {
    type: RESET_PASSWORD,
    user_id,
    token,
    password,
  };
}

export function logout() {
  return {
    type: LOGOUT,
  };
}

export function setAuthToken(token) {
  return {
    type: SET_TOKEN,
    token,
  };
}

export function clearAuthToken() {
  return {
    type: SET_TOKEN,
  };
}

export function updateProfile(profile) {
  return {
    type: UPDATE_PROFILE,
    profile,
  };
}

export function updateChildren(children) {
  return {
    type: UPDATE_CHILDREN,
    children,
  };
}

export function addChild(name, birthday) {
  return {
    type: ADD_CHILD,
    name,
    birthday,
  };
}

export function updateAnalyticsProfile() {
  return {
    type: UPDATE_ANALYTICS_PROFILE,
  };
}

export function clearProfile() {
  return {
    type: UPDATE_PROFILE,
  };
}

export function failedLogin(code) {
  return {
    type: FAILED_LOGIN,
    code,
  };
}

export function failedRegister(code) {
  return {
    type: FAILED_REGISTER,
    code,
  };
}

export function failedPasswordReset() {
  return {
    type: FAILED_PASSWORD_RESET,
  };
}

export function trackEvent(event, data) {
  return {
    type: TRACK_EVENT,
    event,
    data,
  };
}



// WEBPACK FOOTER //
// ./app/redux/reducers/user.js